import { LINK_PREVIEW } from '../constants';
import type { LinkPreviewAttributes, LinkPreviewElement } from '../types';

/** Create a link preview element */
export const createLinkPreview = (attributes: LinkPreviewAttributes): LinkPreviewElement => {
    return { type: LINK_PREVIEW, ...attributes, children: [{ text: '' }] };
};
